<template>
  <LoginForm />
</template>

<script setup>
import LoginForm from "@/components/parent/LoginForm.vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { useSchoolStore } from "@/stores/school";
import { useRoute } from "vue-router";
import { onMounted } from "vue";
import { isLink } from "@/utils";

const authenticationStore = useAuthenticationStore();
const schoolStore = useSchoolStore();
const route = useRoute();

function logout() {
  authenticationStore.logout();
  if (schoolStore.school?.school_url && isLink(schoolStore.school.school_url)) {
    document.location.href = schoolStore.school.school_url;
  } else {
    const add = authenticationStore.level === "parent" ? "" : "/" + authenticationStore.level;
    location.pathname = "/" + route.params.account + add + "/login";
  }
}
onMounted(() => {
  logout();
});
</script>
